import(/* webpackMode: "eager" */ "/var/www/cara-front-new/app/[locale]/quillEditor.css");
;
import(/* webpackMode: "eager" */ "/var/www/cara-front-new/app/[locale]/globals.css");
;
import(/* webpackMode: "eager" */ "/var/www/cara-front-new/app/[locale]/gridPage.scss");
;
import(/* webpackMode: "eager" */ "/var/www/cara-front-new/app/[locale]/swiper.css");
;
import(/* webpackMode: "eager" */ "/var/www/cara-front-new/app/[locale]/multiRangeSlider.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cara-front-new/app/[locale]/ui-layout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cara-front-new/components/structure/GeneralContent/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/cara-front-new/components/structure/JsonLd.tsx/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LayoutProvider"] */ "/var/www/cara-front-new/context/LayoutContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/cara-front-new/node_modules/quill/dist/quill.snow.css");
;
import(/* webpackMode: "eager" */ "/var/www/cara-front-new/node_modules/@smastrom/react-rating/dist/style.css");
;
import(/* webpackMode: "eager" */ "/var/www/cara-front-new/node_modules/next/font/local/target.css?{\"path\":\"app/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/Raleway/Raleway-Regular.ttf\",\"variable\":\"--font-roboto\",\"display\":\"swap\"}],\"variableName\":\"roboto\"}");
;
import(/* webpackMode: "eager" */ "/var/www/cara-front-new/node_modules/next/font/local/target.css?{\"path\":\"app/fonts.ts\",\"import\":\"\",\"arguments\":[{\"src\":\"./fonts/IRANSans2/Farsi_numerals/webFonts/fonts/ttf/IRANSansWeb(FaNum).ttf\",\"variable\":\"--font-iransans\",\"display\":\"swap\"}],\"variableName\":\"iransans\"}");
